import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GcIconComponent,
  GcLoadingSpinnerComponent,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-popup-pdf-download-trigger',
  standalone: true,
  imports: [GcIconComponent, GcLoadingSpinnerComponent],
  templateUrl: './pdf-download-trigger.component.html',
  styleUrl: './pdf-download-trigger.component.scss',
})
export class PdfDownloadTriggerComponent {
  @Input() isLoading = false;
  @Input() tooltip = 'Download PDF report';

  @Output() trigger = new EventEmitter<MouseEvent>();
  @Output() triggerKeydown = new EventEmitter<KeyboardEvent>();

  onTrigger(event: MouseEvent): void {
    this.trigger.emit(event);
  }

  onTriggerKeydown(event: KeyboardEvent): void {
    this.triggerKeydown.emit(event);
  }
}
